export enum Region {
    Flanders = "Flanders",
    Wallonia = "Wallonia",
    Brussels = "Brussels",
}

export enum Income {
    //Boundary values differ per region
    Low = "Low",
    LowMedium = "LowMedium",
    Medium = "Medium",
    High = "High"
}

export enum BreakdownType {
    Basis,
    Leeftijd,
    Mindervalide,
    Wees,
    Toeslag
}

export enum Handicap {
    None = 0,
    Level1,
    Level2,
    Level3,
    Level4,
    Level5,
    Level6,
    Level7,
    Level8,
    Level9
}

export interface CalculationInputDto {
    region: Region;
    family: FamilyInput;
    children: ChildInput[];
}

export interface FamilyInput {
    income: Income;
    isSingleParent: boolean;
    isLangdurigZiek: boolean;
}

export interface ChildInput {
    name: string;
    dateOfBirth: string;
    isInOldSystem: boolean;
    isOrphan: boolean;
    IsOrphanBeforeMilestone: boolean;
    areBothParentsDeceased: boolean;
    handicap: Handicap;
}


export interface CalculationResultDto {
    region: Region;
    result: Calculation;
}

export interface Calculation {
    totalAmount: number;
    children: ChildCalculation[];
}

export interface ChildCalculation {
    name: string;
    totalAmount: number;
    breakdown: CalculationBreakdown[];
    calculationStrategy: string;
}

export interface CalculationBreakdown {
    type: BreakdownType;
    amount: number;
}